import React, { useState, useEffect } from "react";
import "./header.styles.scss";
import { Navbar, Nav } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {
  selectUserEmail,
  selectVerifiedStatus,
  selectUserName,
  selectCorpDetails,
} from "../../redux/user/user.selector";
import { selectSideNavToggle } from "../../redux/side-menu/side-menu.selector";
import { List, ChevronDown, ChevronUp } from "react-bootstrap-icons";
import ProfileIcon from "../profile-icon/profileIcon.component";
import { signoutSuccess } from "../../redux/user/user.actions";
import EditProfile from "../edit-profile/editProfile.component";
import { toastSuccessMessagePopUp } from "../../utils/toastMessagePopup";
import MfaSetting from "../mfa-settings/mfasetting.component";
import { toggleSideNav } from "../../redux/side-menu/side-menu.actions";
import { useHistory } from "react-router";
import { withRouter } from "react-router-dom";

const Header = ({
  isUserVerified,
  signOut,
  sideNavToggle,
  toggleSideNav,
  userEmail,
  userName,
  location,
  corpDetails,
}) => {
  const history = useHistory();
  const [showMfaSettingComponent, setShowMfaSettingComponent] = useState(false);

  // showEditProfileComponent is used check if to show EditProfile popup
  const [showEditProfileComponent, setShowEditProfileComponent] =
    useState(false);

  // state for showing upward or downward arrow while opening profile options menu
  const [isProfilePopupOpen, setProfilePopupStatus] = useState(false);

  const toggleShowMfaSettingComponent = () => {
    //  is called when we want open side drawer
    toggleSideNav();
  };

  let value = location.pathname.split("/").pop();

  // this function is called on clicking name or dropdown arrow and
  // closes or opens the profile popup menu by inverting its current state
  const openCloseProfilePopup = () => {
    document.addEventListener("click", () => {
      /* we get the dropdown element using "getElementByClassName" selector and check 
                if the element has a class named "show" which is set by react-bootstrap which then
                makes the dropdown menu visible and removes the class to close the menu.
                so if class "show" is present then we also set the "isProfilePopupOpen" state
                to true which then render an upward arrow for the dropdown and vice versa
            */
      if (document.getElementsByClassName("dropdown").length) {
        if (
          document
            .getElementsByClassName("dropdown")[0]
            .classList.contains("show")
        )
          setProfilePopupStatus(true);
        else setProfilePopupStatus(false);
      }
    });
  };

  // this function changes the state for profilePopupMenu arrow
  const handleClickOutside = (event) => {
    setProfilePopupStatus(false);
  };

  useEffect(() => {
    /* this logic  add an event listener which checks for "click" event so 
         when we click anywhere, then it calls the "closeProfilePopup" 
         function which then changes the state of popupMenuOpen to false and results in 
         showing downward arrow for profile options. 
         NOTE:// the dropdown(profile options or popup) menu is closed automatically by react-bootstrap
         component, the state which we are setting here is only for showing the upward or downward arrow
         */
    if (isProfilePopupOpen) {
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }
  }, [isProfilePopupOpen]);

  const openEditProfileModal = () => {
    //  is called when we want Edit Profile modal to be visible
    if (!showEditProfileComponent) {
      setShowEditProfileComponent(true);
    }
  };

  const openShowMfaSettingComponent = () => {
    //  is called when we want Edit Profile modal to be visible
    if (!showMfaSettingComponent) {
      setShowMfaSettingComponent(true);
    }
  };

  const closeEditProfileModal = (message) => {
    // is called when we want to close the Edit Profile modal
    setShowEditProfileComponent(false);
    if (message) {
      toastSuccessMessagePopUp(message);
    }
  };

  const closeShowMfaSettingComponent = (message) => {
    // is called when we want to close the Edit Profile modal
    setShowMfaSettingComponent(false);
    if (message) {
      toastSuccessMessagePopUp(message);
    }
  };

  const checkLocationPathName = () => {
    if (
      value === "firewall" ||
      value === "importdata" ||
      value === "add-customer"
    )
      return true;
    else return false;
  };

  return !isUserVerified ? (
    // if authentication data is not present then render this
    // react-bootstrap Navbar component
    <Navbar bg="dark" variant="dark" className="color-nav"></Navbar>
  ) : (
    // else render this react-bootstrap Navbar component
    <>
      <Navbar
        bg="light"
        variant="light"
        className={"light-nav " + (sideNavToggle ? "active-header" : "")}
      >
        {/* list icon */}
        {checkLocationPathName() ? (
          // show back icon instead of hamburger if user is on "add-user" page
          <div
            className="back-button-arrow"
            onClick={() => {
              history.goBack();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              width="23"
              height="23"
              fill="black"
              stroke="black"
              strokeWidth="1.2"
            >
              <path
                fillRule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              ></path>
            </svg>
          </div>
        ) : (
          <Navbar.Brand onClick={toggleShowMfaSettingComponent}>
            <List color="black" size={30} />
          </Navbar.Brand>
        )}
        {/* page title */}
        <Navbar.Brand>
          {
            // subtitle
            value === "add-user" ? (
              <div id="sub-title">USERS</div>
            ) : value === "add-customer" ? (
              <div id="sub-title">CUSTOMERS</div>
            ) : value === "firewall" ? (
              <div id="sub-title">EDIT RULES</div>
            ) : value === "importdata" ? (
              <div id="sub-title">IMPORT DATA</div>
            ) : null
          }
          <div
            className={
              value === "add-user" ||
              value === "add-customer" ||
              value === "firewall" ||
              value === "importdata"
                ? "main-title"
                : ""
            }
          >
            {/* page title - we get the page title from the route by splitting the link at "/".
          "react-router-dom's" "withRouter" HOC sends 'location' object in the props
           and we use its 'pathname' key to get page-route */}
            {value === "customers" || value === "login-audit"
              ? "Reseller View"
              : value === "mivb-smdr-enabler" || value === "json-configuration"
              ? "Tools"
              : value === "add-customer"
              ? "Add Customer"
              : value === "add-user"
              ? "Add User"
              : value === "firewall"
              ? corpDetails.corpName
              : value === "importdata"
              ? corpDetails.corpName
              : value}
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          {/* empty nav which is positioned left so that the dropdown we create after this is positioned to right */}
          <Nav className="mr-auto"></Nav>
          {/* second nav which contains profile icon */}
          <Nav>
            <Nav.Item>
              <ProfileIcon />
            </Nav.Item>
          </Nav>
          {/* third nav which contains dropdown and email and are stacked vertically*/}
          <Nav className="flex-column">
            <Dropdown
              alignRight
              id="dropdown-menu-align-right"
              onClick={openCloseProfilePopup}
            >
              <Dropdown.Toggle id="header-dropdown-basic">
                <span className="header-user-name">{userName}</span>
                {isProfilePopupOpen ? <ChevronUp /> : <ChevronDown />}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  className="header-dropdown-item"
                  onClick={openEditProfileModal}
                >
                  Edit Profile
                </Dropdown.Item>
                <Dropdown.Item
                  className="header-dropdown-item"
                  onClick={openShowMfaSettingComponent}
                >
                  MFA Settings
                </Dropdown.Item>
                <Dropdown.Divider />

                <Dropdown.Item
                  className="header-dropdown-item"
                  onClick={() => {
                    signOut();
                    history.push("/");
                  }}
                >
                  Log out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <Nav.Item className="hide">{userEmail}</Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      {/* the EditProfile component will render depending on showEditProfileComponent */}
      {showEditProfileComponent ? (
        <EditProfile closeComponent={closeEditProfileModal} />
      ) : null}
      {showMfaSettingComponent ? (
        <MfaSetting closeComponent={closeShowMfaSettingComponent} />
      ) : null}
    </>
  );
};

// mapStateToProps provides us the required state stored in the redux store
const mapStateToProps = createStructuredSelector({
  isUserVerified: selectVerifiedStatus,
  sideNavToggle: selectSideNavToggle,
  userEmail: selectUserEmail,
  userName: selectUserName,
  corpDetails: selectCorpDetails,
});

const mapDispatchToProps = (dispatch) => ({
  signOut: () => dispatch(signoutSuccess()),
  toggleSideNav: (status) => dispatch(toggleSideNav(status)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
